import React, { useEffect, useState } from "react";
import { getPrivacyPolicy, getSeoByUrl } from "../api/api";
import { Helmet } from "react-helmet-async";

const PrivacyPolicy = () => {
  const [policy, setPolicy] = useState("");
  const [seoData, setSeoData] = useState({});

  useEffect(() => {
    const fetchPolicy = async () => {
      const response = await getPrivacyPolicy();
      if (response.status && response.data && response.data.privacy_policy) {
        setPolicy(response.data.privacy_policy);
      } else {
        setPolicy("<p>Failed to load privacy policy.</p>");
      }
    };
    fetchPolicy();
  }, []);

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await getSeoByUrl("privacy-policy");
        if (response.success && response.data) {
          setSeoData(response.data);
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      }
    };
    fetchSeoData();
  }, []);

  return (
    <div className="custom-padding xl-screen-padding pt-80 pb-80 font-lato">
      <Helmet>
        <title>
          {seoData.metaTitle || "Privacy Policy | Nutrillion"}
        </title>

        <meta
          name="description"
          content={seoData.metaDescription || "Read Nutrillion's privacy policy for data protection"}
        />

        <meta
          name="robots"
          content={seoData.robotsTxt || "index, follow"}
        />

        <link
          rel="canonical"
          href={seoData.canonicalUrl || "https://nutrillion.one/privacy-policy"}
        />
      </Helmet>
      <div className="policy-content" dangerouslySetInnerHTML={{ __html: policy }} />
    </div>
  );
};

export default PrivacyPolicy;